import { inject, Injectable, signal } from '@angular/core';
import { CanActivateChildFn, CanDeactivateFn } from '@angular/router';

/**
 * Tracks whether a confirm dialog with an async `onConfirm` action is currently open.
 *
 * Injected by `ConfirmDialogComponent` to set/clear the blocked state automatically.
 * Route guards read the signal to prevent navigation while a dialog action is in flight.
 */
@Injectable({ providedIn: 'root' })
export class DialogNavigationGuardService {
    readonly blocked = signal(false);
}

/**
 * Prevents the host component from deactivating while a confirm dialog action is in progress.
 * Apply to a route's `canDeactivate` array.
 */
export const dialogCanDeactivate: CanDeactivateFn<unknown> = () => {
    const service = inject(DialogNavigationGuardService);
    return !service.blocked();
};

/**
 * Prevents child route activation while a confirm dialog action is in progress.
 * Apply to a route's `canActivateChild` array.
 */
export const dialogCanActivateChild: CanActivateChildFn = () => {
    const service = inject(DialogNavigationGuardService);
    return !service.blocked();
};
